import { createSelector } from 'reselect';

import { getLocaleUrlPath } from 'utils';

const getSeo = state => state.seo;

export const makeGetSeoUrl = () => {
  return createSelector(
    (state, props) => props.location.pathname,
    (state, props) => props.locale || props.intl.locale,
    (pathname, locale) => {
      return `${getLocaleUrlPath(locale)}${
        process.env.APP_ROUTER_BASENAME
      }${pathname}`;
    }
  );
};

export const makeGetSeoByUrl = () => {
  const getSeoUrl = makeGetSeoUrl();

  return createSelector(getSeo, getSeoUrl, (seo, seoUrl) => {
    return seo[seoUrl] || {};
  });
};

export const makeGetSeoMeta = () => {
  const getSeoByUrl = makeGetSeoByUrl();

  return createSelector(getSeoByUrl, seo => seo.meta || {});
};

export const getSeoMeta = makeGetSeoMeta();

export const makeGetSeoLinksBlocks = () => {
  const getSeoByUrl = makeGetSeoByUrl();

  return createSelector(getSeoByUrl, seo => seo.linksBlocks || {});
};

export const makeGetSeoLinksBlocksItems = () => {
  const getSeoLinksBlocks = makeGetSeoLinksBlocks();

  return createSelector(getSeoLinksBlocks, seoLinksBlocks => {
    const ids = seoLinksBlocks?.ids;
    const links = seoLinksBlocks?.entities?.links;

    if (!Array.isArray(ids) || ids.length === 0 || !links) {
      return [];
    }

    const linksSeo = ids
      .map(id => links[id])
      .filter(item => item && typeof item === 'object');

    const newSeo = [];

    linksSeo.forEach(item => {
      if (!Array.isArray(item.children)) {
        return;
      }

      item.children.forEach(childId => {
        const child = links[childId];
        if (
          child &&
          Array.isArray(child.children) &&
          child.children.length > 0
        ) {
          newSeo.push(child);
        }
      });
    });

    const result = linksSeo.filter(
      item => !newSeo.some(child => child.parrentId === item.id)
    );

    const seoLinks = [...result, ...newSeo];

    return newSeo.length > 0
      ? seoLinks.sort((a, b) => 1 * (a.sort || 0) - 1 * (b.sort || 0))
      : linksSeo;
  });
};

export const makeGetSeoTextsBlocks = () => {
  const getSeoByUrl = makeGetSeoByUrl();

  return createSelector(getSeoByUrl, seo => seo.texts || {});
};

export const makeGetSeoTextsBlocksItems = () => {
  const getSeoTextsBlocks = makeGetSeoTextsBlocks();

  return createSelector(
    getSeoTextsBlocks,
    seoTextsBlocks => seoTextsBlocks.items || []
  );
};

const getSeoByUrl = makeGetSeoByUrl();

export const makeGetBreadcrumbs = () =>
  createSelector(getSeoByUrl, seo => seo.breadcrumbs || {});

export const getBreadcrumbs = makeGetBreadcrumbs();
